import React from "react";
import { FloatingLabel, Form } from "react-bootstrap";
import HelpButton from "../HelpContent/HelpButton";
import MyIcon from "../Common/MyIcon";
import BillingDetailsIcon from "../../assets/icons/invoice_history.svg2";

export default function BillingDetails({
  handleBillingChange,
  billingSettings,
  errors,
}) {
  return (
    <div>
      <div className="bg-purple-gradient-darker-reverse rounded-4 p-3 ">
            <>
              <h5 className=" d-flex align-items-center">
                <MyIcon Icon={BillingDetailsIcon} className="me-2" />
                <span className="ms-2">
                  <span className="fw-bold me-2"> Billing details:</span>
                  <HelpButton helpKey="settings-billing-details"/>
                  <div className="small text-secondary">
                    Manage billing details
                  </div>
                </span>
              </h5>
            </>
          <hr className="my-3 text-secondary" />
          <div className="row">
            <div className="col-6">
              <FloatingLabel label="Company Name:" className="mb-2">
                <Form.Control
                  name="company_name"
                  placeholder="Company Name"
                  onChange={handleBillingChange}
                  value={billingSettings.company_name}
                />
              </FloatingLabel>
              {errors?.company_name && (
                <div className="alert alert-danger">{errors?.company_name}</div>
              )}
            </div>
            <div className="col-6">
              <FloatingLabel label="Registration Number:" className="mb-2">
                <Form.Control
                  type="number"
                  onChange={handleBillingChange}
                  name="company_num"
                  placeholder="Registration Number"
                  value={billingSettings.company_num}
                />
              </FloatingLabel>
              {errors?.company_num && (
                <div className="alert alert-danger">{errors?.company_num}</div>
              )}
            </div>
            <div className="col-6">
              <FloatingLabel label="VAT Number:" className="mb-2">
                <Form.Control
                  type="number"
                  onChange={handleBillingChange}
                  placeholder="VAT Number"
                  name="vat_number"
                  value={billingSettings.vat_number}
                />
              </FloatingLabel>
              {errors?.vat_number && (
                <div className="alert alert-danger">{errors?.vat_number}</div>
              )}
            </div>
            <div className="col-6">
              <FloatingLabel
                label="Billing Address (including postcode):"
                className="mb-2"
              >
                <Form.Control
                  as="textarea"
                  name="invoicing_address"
                  placeholder="Billing Address"
                  onChange={handleBillingChange}
                  value={billingSettings.invoicing_address}
                />
              </FloatingLabel>{" "}
            </div>
          </div>

          {errors?.invoicing_address && (
            <div className="alert alert-danger">
              {errors?.invoicing_address}
            </div>
          )}
      </div>
    </div>
  );
}
